import { SetStateAction, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import LoaderOverlay from "../loading_page/loading_page";
import htmlToDraft from "html-to-draftjs";
import dompurify from "dompurify";
import axios from "axios";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import _ from "lodash";
import "./write_page.css";

type PostType = {
  postType: string;
};

function WritePage({ postType }: PostType) {
  const [cookie, setCookie] = useCookies(["admin"]);
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const [title, setTitle] = useState("");
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filesName, setFilesName] = useState<string[]>();
  const navigate = useNavigate();

  if (postType !== "notice" && postType !== "info" && postType !== "qna")
    navigate("/noMatch");

  const onTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setTitle(value);
  };

  const onEditorStateChange = (editorState: any) => {
    setEditorState(editorState);
  };

  const onAttachFiles = (event: any) => {
    setFiles(event.target.files);

    const list = [];
    for (const file of event.target.files) {
      list.push(file.name);
    }

    setFilesName(list);
  };

  const onSaveBtnClicked = () => {
    if (_.isEmpty(title)) {
      return alert("제목을 입력해주세요.");
    }

    const postCreateAPI = process.env.REACT_APP_SERVER_URI + "/post";
    const formData = new FormData();
    const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));

    formData.append("postType", postType);
    formData.append("title", title);
    formData.append("content", html);
    for (const file of files) {
      formData.append("file", file);
    }

    setIsLoading(true);

    axios
      .post(postCreateAPI, formData, {
        headers: {
          Authorization: cookie.admin,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        navigate("/community/" + postType);
      })
      .catch((error) => {
        alert(error.response.data.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="write_page">
      <div className="title_write_container">
        <label>제목</label>
        <input
          className="title_input"
          type="text"
          value={title}
          onChange={onTitleChange}
        ></input>
      </div>
      <Editor
        editorState={editorState}
        wrapperClassName="editor_container"
        editorClassName="post_editor"
        toolbarClassName="editor_tool_bar"
        onEditorStateChange={onEditorStateChange}
        localization={{
          locale: "ko",
        }}
      />
      <div className="file_container">
        <input
          className="file_list"
          value={filesName}
          placeholder="첨부파일 다중 선택 가능"
        />
        <input
          className="file_input_btn"
          type="file"
          multiple
          onChange={onAttachFiles}
        />
      </div>
      <div className="write_btn_container">
        <button className="write_btn" onClick={onSaveBtnClicked}>
          저장
        </button>
      </div>
      <LoaderOverlay open={isLoading} text="데이터를 저장하는 중입니다" />
    </div>
  );
}

export default WritePage;
